var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-test-id":"AgeAndGender"}},[_c('div',{staticClass:"d-flex"},[_c('age',{attrs:{"selected-age":_vm.adaptedAge},on:{"age-updated":_vm.ageUpdated}}),_c('gender',{attrs:{"selected-gender":_vm.gender},on:{"gender-updated":_vm.genderUpdated}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }